/**
 * 判断当前是否为node环境
 */
const isNode = typeof window === 'undefined'

export default isNode
